<template>
    <div :class="{'opacity-50 cursor-not-allowed': inProgress}">
        <form autocomplete="off" name="formrequest" v-on:submit.prevent="companySave()">
            <h2 class="text-red text-lg text-bold mb-5 pb-2 py-6 border-red-light border-b">
                Entreprise
            </h2>
            <div v-if="isSubmitted && errors == null" class="alert alert-success bg-green-light border border-green text-green px-4 py-3 rounded relative mb-4">
                <p class="mb-0">
                    <strong class="font-bold">{{ $t("form.submitted") }}</strong>
                </p>
            </div>
            <div v-if="errors.length" class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4" role="alert">
                <p class="mb-0">
                    <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
                </p>
                <ul class="error-messages block sm:inline text-left p-0 list-reset">
                    <li v-for="error in errors">
                        <span v-if="error.message"> {{ error.message }}</span>
                    </li>
                </ul>
            </div>

            <div v-if="messageCompany" class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4">
                {{ $t('company.messageCompany') }}
            </div>

            <div class="flex my-8 max-w-md">
                <div class="flex-1 px-4 py-2">
                    <sp-input theme="team" name="legal_name" v-model="company.legal_name" :label="$t('company.legal_name')" :required="true" :disabled="(company.legal_name != null)">
                    </sp-input>
                    <sp-input theme="team" name="tax_identification_number" v-model="company.tax_identification_number" :label="$t('company.tax_identification_number')" :required="true" :disabled="(company.tax_identification_number != null)">
                    </sp-input>
                    <sp-input theme="team" name="cnss_affiliation_number" v-model="company.cnss_affiliation_number" :label="$t('company.cnss_affiliation_number')"></sp-input>
                    <sp-input theme="team" name="address" v-model="company.address" :label="$t('company.address')" :required="true"></sp-input>

                    <sp-delegation-list @select-change="delegationChange" :selectedgovernorate="company.governorate" :selecteddelegation="company.delegation" :edited="edit" @edit-change-deleg="editChangeDel"></sp-delegation-list>

                    <sp-input theme="team" name="code_postal" v-model="company.code_postal" :label="$t('company.code_postal')" :required="true"></sp-input>
                    <sp-input theme="team" name="locality" v-model="company.locality" :label="$t('company.locality')" :required="true"></sp-input>
                    <sp-input theme="team" name="phone" v-model="company.phone" :label="$t('company.phone')" :required="true" type="number">
                    </sp-input>
                    <sp-input theme="team" name="email" v-model="company.email" :label="$t('company.email')" :required="true"></sp-input>
    
                    <sp-activity-list @select-change="activityChange" :selecteddomain="company.activity_domain" :selectedsector="company.sector" :selectedFirstLevel="company.first_level_activity" :selectedSecondLevel="company.second_level_activity" :selectedThreeLevel="company.three_level_activity" :selectedFourLevel="company.four_level_activity" :edited="edit" @edit-change-act="editChange"></sp-activity-list>
    
                    <div class="form-control relative mb-5">
                        <label class="block text-blue text-2sm font-bold mb-3">{{ $t('company.legal_form') }}</label>
                        <sp-radio theme="team" v-model="company.legal_form" v-for='(op, index) in [{"name":"SUARL","value":"SUARL","default":"0"},{"name":"SARL","value":"SARL","default":"0"},{"name":"SA","value":"SA","default":"0"},{"name":"SAS","value":"SAS","default":"0"},{"name":"Autre","value":"Autre","default":"0"}]'
                            :key="index" name="legal_form" :id="'legal_form'+index" :value="op.value">{{ op.name }}</sp-radio>
                    </div>
                    
                    <sp-input theme="team" name="effective_women" v-model="company.effective_women" :label="$t('company.effective_women')" :required="true" type="number">
                    </sp-input>
                    <sp-input theme="team" name="effective_men" v-model="company.effective_men" :label="$t('company.effective_men')" :required="true" type="number">
                    </sp-input>
                    <!--<label class="block text-blue text-2sm font-bold mb-3">{{ $t("company.dateStart") }}</label>
                    <flat-picker v-model="company.date_start" :config="{ dateFormat: 'Y-m-d' ,enable: [company.date_start]}"  placeholder="Date de démarrage" class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight">
                    </flat-picker>-->

                    <div class="form-control relative mb-5">
                        <label class="block text-blue text-2sm font-bold mb-3">{{ $t('company.situation') }}</label>
                        <sp-radio theme="team" v-model="company.situation" v-for="(op, index) in [{name:'En activité',value:'En activité'},{name:'En démarrage',value:'En démarrage'}]" :key="index" :name="'situation'+index" :id="'situation'+index" :value="op.value">{{ op.name }}</sp-radio>
                    </div>
    
                    <sp-input theme="team" name="gerant" v-model="company.gerant" :label="$t('company.gerant')"></sp-input>
    
                    <h2 class="text-red text-lg text-bold mb-5 pb-2 py-6 border-red-light border-b">
                        {{ $t('company.person_contact') }}
                    </h2>
                    <sp-input theme="team" name="contact_fullname" v-model="company.contact_fullname" :label="$t('company.contact_fullname')" :required="true">
                    </sp-input>
                    <sp-input theme="team" name="contact_quality" v-model="company.contact_quality" :label="$t('company.contact_quality')" :required="true">
                    </sp-input>
                    <sp-input theme="team" name="contact_phone" v-model="company.contact_phone" :label="$t('company.contact_phone')" :required="true" type="number">
                    </sp-input>
                  
                    <sp-dropzone theme="form" :required="true" id="file_patente_id" label="Veuillez uploader une copie de la Patente" :url="url" :vdropzonesuccess="PatentedropzoneSuccess" :vdropzoneError="PatentevdropzoneError" tag="4" :vdropzone-removed-file="PatentevdropzoneRemovedFile"
                        :vdropzoneProcessing="vdropzoneProcessing" :cinFile="company.file_patente_id" :maxFiles="maxFiles" :downloadFile ="true" :disabled="(company.file_patente_id != null)">
                    </sp-dropzone>

                    <!--<div class="form-control relative mb-5 mt-5">
                        <sp-checkbox
                          theme="team"
                          name="option"
                          id="benefit_support_cnss"
                          :checked="company.benefit_support_cnss"
                          @input="checkboxUpdate"
                          >{{ $t("company.benefit_support_cnss") }}</sp-checkbox
                        >
                    </div>-->
                    <sp-dropzone theme="form" id="file_afiliation" label="Veuillez uploader une copie de l'afiliation CNSS" :url="url" :vdropzonesuccess="afiliationdropzoneSuccess" :vdropzoneError="afiliationvdropzoneError" tag="2" :vdropzone-removed-file="afiliationvdropzoneRemovedFile"
                        :vdropzoneProcessing="vdropzoneProcessing" :cinFile="company.file_afiliation_cnss_id" :maxFiles="maxFiles"  :downloadFile ="true" :disabled="(company.file_afiliation_cnss_id != null)">
                    </sp-dropzone>
                    <sp-dropzone theme="form" id="file_listing_employees" label="Veuillez remplir et uploader au format Excel la liste des salariés assujettis à la CNSS. Le fichier modèle est disponible à partir du lien suivant: " :url="url" :vdropzonesuccess="ListingEmployeesdropzoneSuccess" :vdropzoneError="ListingEmployeesvdropzoneError" tag="2"  acceptedFiles="xlsx,xlsm,xltx,xltm,xls,xlt,xla,xlsx,csv,text/csv,application/vnd.ms-excel,application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :vdropzone-removed-file="ListingEmployeesvdropzoneRemovedFile"
                        :vdropzoneProcessing="vdropzoneProcessing" :isExcel="true" :cinFile="company.file_listing_employees_id" :maxFiles="maxFiles" :downloadFile ="true" :isCompany="true" :disabled="(company.file_listing_employees_id != null)">
                    </sp-dropzone>
    
                </div>
            </div>
            <sp-button theme="outline-blue" space="small" class="" type="submit">{{ $t("form.send")}}
            </sp-button>
    
        </form>
    </div>
</template>

<script>
import {
    COMPANY_SAVE
} from "@/store/actions.type";
import InputVue from "../../components/spKit/Input.vue";
import TextareaVue from "../../components/spKit/Textarea.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import RadioVue from '../../components/spKit/Radio.vue';
import CheckboxVue from "../../components/spKit/Checkbox.vue";

import DropZoneVue from "../../components/spKit/DropZone.vue";
import { API_URL } from "@/common/config";
import ActivityListVue from '../../components/spKit/Activity-list.vue';
import DelegationListVue from '../../components/spKit/Delegation-list.vue';
const uploadURL = API_URL + "/documents/upload";
import ButtonVue from '../../components/spKit/Button.vue';

export default {
    name: "company",
    components: {
        "sp-button": ButtonVue,
        "sp-input": InputVue,
        "sp-textarea": TextareaVue,
        "sp-radio": RadioVue,
        "sp-checkbox": CheckboxVue,
        "flat-picker": flatPickr,
        "sp-dropzone": DropZoneVue,
        "sp-activity-list": ActivityListVue,
        "sp-delegation-list": DelegationListVue
    },
    data() {
        return {
            url: uploadURL,
            maxFiles: 1,
            errors: [],
            inProgress: false,
            isSubmitted: false,
            uploadAfiliation: [],
            uploadPatente: [],
            uploadCommerce: [],
            uploadListingEmployees: [],
            filesUploadedCommerce: null,
            messageCompany: false,
            company: {
                "legal_name": null,
                "tax_identification_number": null,
                "cnss_affiliation_number": null,
                "address": null,
                "governorate": null,
                "delegation": null,
                "code_postal": null,
                "locality": null,
                "phone": null,
                "email": null,
                "activity_domain": null,
                "sector": null,
                "first_level_activity": null,
                "second_level_activity": null,
                "three_level_activity": null,
                "four_level_activity": null,
                "effective_women": null,
                "effective_men": null,
                //"date_start": null,
                "situation": null,
                "gerant": null,
                "contact_fullname": null,
                "contact_quality": null,
                "contact_phone": null,
                "file_patente_id": null,
                "file_afiliation_cnss_id": null,
                //"benefit_support_cnss": null,
                "file_listing_employees_id": null
            }

        }
    },
    props: {
        appId: {
            required: true,
            type: String,
            default: null
        },
        data: {
            required: false,
            type: Object,
            default: null
        },
        edit:{
            required:false,
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.company = this.data;
    },
    methods: {
        editChange(val){
            this.$emit("edit-change",val);
        },
        editChangeDel(val){
            this.$emit("edit-change",val);
        },
        companySave() {
            let companyForm = Object.assign({}, this.company);
            if (companyForm.file_patente_id) companyForm.file_patente_id = this.company.file_patente_id.id;
            if (typeof this.uploadPatente[0] != "undefined")
                companyForm.file_patente_id = this.uploadPatente[0];

            if (companyForm.file_afiliation_cnss_id) companyForm.file_afiliation_cnss_id = this.company.file_afiliation_cnss_id.id;
            if (typeof this.uploadAfiliation[0] != "undefined")
                companyForm.file_afiliation_cnss_id = this.uploadAfiliation[0];

            if (companyForm.file_listing_employees_id) companyForm.file_listing_employees_id = this.company.file_listing_employees_id.id;
            if (typeof this.uploadListingEmployees[0] != "undefined")
                companyForm.file_listing_employees_id = this.uploadListingEmployees[0];
                           // Validation
            let validationErrors = [];
            if (!companyForm.file_patente_id) {
                validationErrors.push('fichier Patente est obligatoire.');
            }
            if (!companyForm.file_afiliation_cnss_id) {
                validationErrors.push('fichier Afiliation CNSS est obligatoire.');
            }
            if (!companyForm.file_listing_employees_id) {
                validationErrors.push('fichier Liste Employées est obligatoire.');
            }

            if (validationErrors.length > 0) {
                this.errors = validationErrors;
                window.scrollTo(0, 0);
                return;
            }
            this.inProgress = true;
            this.$store.dispatch(COMPANY_SAVE, { form: companyForm, app_id: this.appId })
                .then(() => {
                    window.scrollTo(0, 0);
                    this.inProgress = false;
                    this.errors = [];
                    this.messageCompany = true;
                    this.$emit('save-company', this.messageCompany);

                })
                .catch(({
                    response
                }) => {
                    window.scrollTo(0, 0);
                    this.inProgress = false;
                    if (response) this.errors = response.data.meta.errors;
                });
        },
        activityChange(val) {
            switch (val[0]) {
                case 'domain':
                    this.company.activity_domain = val[1];
                    this.company.sector = null;
                    break;
                case 'sector':
                    this.company.sector = val[1];
                    this.company.first_level_activity = null;
                    this.company.second_level_activity = null;
                    this.company.three_level_activity = null;
                    this.company.four_level_activity = null;
                    break;
                case 'first_level_activity':
                    this.company.first_level_activity = val[1];
                    this.company.second_level_activity = null;
                    this.company.three_level_activity = null;
                    this.company.four_level_activity = null;
                    break;
                case 'second_level_activity':
                    this.company.second_level_activity = val[1];
                    this.company.three_level_activity = null;
                    this.company.four_level_activity = null;
                    break;
                case 'three_level_activity':
                    this.company.three_level_activity = val[1];
                    this.company.four_level_activity = null;
                    break;
                case 'four_level_activity':
                    this.company.four_level_activity = val[1];
                    break;
            }
        },
        delegationChange(val) {
            switch (val[0]) {
                case 'governorate':
                    this.company.governorate = val[1];
                    this.company.delegation = null;
                    break;
                case 'delegation':
                    this.company.delegation = val[1]; 
                    break;
            }
        },
        vdropzoneProcessing(file) {
            this.inProgress = true;
        },
        PatentedropzoneSuccess(file, response) {
            this.inProgress = false;
            this.uploadPatente.push(response.data.document.id);
        },
        PatentevdropzoneError(file, message, xhr) {
            if (xhr != undefined) {
                if (message.meta.status == 400) this.uploadPatente.splice(-1, 1);
            }
            this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
                "you cant upload this file";
        },
        PatentevdropzoneRemovedFile(file, error, xhr) {
            if (xhr != undefined) {
                let data = JSON.parse(file.xhr.response);
                if (data.meta.status == 200) {
                    let index = this.uploadPatente.indexOf(data.data.document.id);
                    if (index > -1) {
                        this.uploadPatente.splice(index, 1);
                    }
                }
            } else {
                let index = this.uploadPatente
                    .map(function(x) {
                        return x;
                    })
                    .indexOf(file.id);
                if (index > -1) {
                    this.uploadPatente.splice(index, 1);
                }
            }
        },
        afiliationdropzoneSuccess(file, response) {
            this.inProgress = false;
            this.uploadAfiliation.push(response.data.document.id);
        },
        afiliationvdropzoneError(file, message, xhr) {
            if (xhr != undefined) {
                if (message.meta.status == 400) this.uploadAfiliation.splice(-1, 1);
            }
            this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
                "you cant upload this file";
        },
        afiliationvdropzoneRemovedFile(file, error, xhr) {
            if (xhr != undefined) {
                let data = JSON.parse(file.xhr.response);
                if (data.meta.status == 200) {
                    let index = this.uploadAfiliation.indexOf(data.data.document.id);
                    if (index > -1) {
                        this.uploadAfiliation.splice(index, 1);
                    }
                }
            } else {
                let index = this.uploadAfiliation
                    .map(function(x) {
                        return x;
                    })
                    .indexOf(file.id);
                if (index > -1) {
                    this.uploadAfiliation.splice(index, 1);
                }
            }
        },
        CommercedropzoneSuccess(file, response) {
            this.inProgress = false;
            this.uploadCommerce.push(response.data.document.id);
        },
        CommercevdropzoneError(file, message, xhr) {
            if (xhr != undefined) {
                if (message.meta.status == 400) this.uploadCommerce.splice(-1, 1);
            }
            this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
                "you cant upload this file";
        },
        CommercevdropzoneRemovedFile(file, error, xhr) {
            if (xhr != undefined) {
                let data = JSON.parse(file.xhr.response);
                if (data.meta.status == 200) {
                    let index = this.uploadCommerce.indexOf(data.data.document.id);
                    if (index > -1) {
                        this.uploadCommerce.splice(index, 1);
                    }
                }
            } else {
                let index = this.uploadCommerce
                    .map(function(x) {
                        return x;
                    })
                    .indexOf(file.id);
                if (index > -1) {
                    this.uploadCommerce.splice(index, 1);
                }
            }
        },

        ListingEmployeesdropzoneSuccess(file, response) {
            this.inProgress = false;
            this.uploadListingEmployees.push(response.data.document.id);
        },
        ListingEmployeesvdropzoneError(file, message, xhr) {
            if (xhr != undefined) {
                if (message.meta.status == 400) this.uploadListingEmployees.splice(-1, 1);
            }
            this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
                "you cant upload this file";
        },
        ListingEmployeesvdropzoneRemovedFile(file, error, xhr) {
            if (xhr != undefined) {
                let data = JSON.parse(file.xhr.response);
                if (data.meta.status == 200) {
                    let index = this.uploadListingEmployees.indexOf(data.data.document.id);
                    if (index > -1) {
                        this.uploadListingEmployees.splice(index, 1);
                    }
                }
            } else {
                let index = this.uploadListingEmployees
                    .map(function(x) {
                        return x;
                    })
                    .indexOf(file.id);
                if (index > -1) {
                    this.uploadListingEmployees.splice(index, 1);
                }
            }
        },
        /*checkboxUpdate(check) {
            this.company.benefit_support_cnss = check;
        },*/

        LegalFormChange(val) {
            this.company.legal_form = val[1]
        }
    }
}
</script>
